import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillingSimulationResult } from 'src/features/billingSimulation/utils/types';

const RESOURCE = '/subscriptions/service-plan/:planId/simulate-billing/';

interface DTO {
    planId: string;
    start_date: string;
    end_date: string;
    discount_policy_ids?: string[];
    voucher_type_ids?: string[];
    item_coefficients?: Record<string, string>;
}

const mutationFn = ({ planId, ...payload }: DTO): Promise<BillingSimulationResult> =>
    axios.post(formatResourcePath(RESOURCE, { planId }), payload);

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useSimulateBilling };
